import { ICinemaPalette, withAlpha } from '../palette';
import { DISP, getSharedTokens, HOVER, INK_DIM, MOBILE } from './styleTokens';

export const getSwitcherStyles = (palette: ICinemaPalette) => {
  const { focusRing } = getSharedTokens(palette);
  const lit = {
    color: '#fff',
    background:
      'linear-gradient(180deg, rgba(255,255,255,.14), rgba(255,255,255,.06))',
    boxShadow: `inset 0 0 0 1px ${withAlpha(
      palette.accentHi,
      0.36,
    )}, 0 2px 10px rgba(4,6,9,.45)`,
  };

  return {
    switcher: {
      flex: 'none',
      display: 'inline-flex',
      alignItems: 'center',
      gap: '2px',
      padding: '3px',
      borderRadius: '12px',
      border: '1px solid rgba(255,255,255,.1)',
      background: 'rgba(4,6,9,.42)',
      boxShadow: 'inset 0 1px 2px rgba(4,6,9,.45)',
      [MOBILE]: { padding: '2px' },
    },
    tab: {
      position: 'relative',
      height: '32px',
      display: 'inline-flex',
      alignItems: 'center',
      gap: '7px',
      padding: '0 13px 0 8px',
      border: 0,
      borderRadius: '9px',
      background: 'transparent',
      color: INK_DIM,
      fontFamily: DISP,
      fontSize: '13px',
      fontWeight: 600,
      letterSpacing: '.01em',
      whiteSpace: 'nowrap',
      cursor: 'pointer',
      transition: 'background .15s, color .15s, box-shadow .15s',
      '& svg': { flex: 'none', opacity: 0.7, transition: 'opacity .15s' },
      '&::before': { content: '""', position: 'absolute', inset: '-6px 0' },
      [HOVER]: {
        '&:hover': {
          color: '#fff',
          background: 'rgba(255,255,255,.07)',
          '& svg': { opacity: 1 },
        },
      },
      '&:active': { background: 'rgba(255,255,255,.1)' },
      '&:focus-visible': focusRing,
      [MOBILE]: { width: '44px', padding: 0, justifyContent: 'center' },
    },
    tabActive: {
      ...lit,
      cursor: 'default',
      '& svg': { opacity: 1 },
      [HOVER]: { '&:hover': lit },
      '&:active': lit,
    },
    tabLabel: {
      [MOBILE]: { display: 'none' },
    },
  };
};
